jQuery(document).ready(function ($) {
	var desktopBreakpoint = 768;
	var closeTimeout;

	function closeSubnav($item) {
		$item.removeClass("is-open");
		$item.find("[data-subnav-trigger]").attr("aria-expanded", "false");
	}

	function closeAllSubnavs(exceptItem) {
		$(".subnav__item.is-open").not(exceptItem).each(function () {
			closeSubnav($(this));
		});
	}

	function openSubnav($item) {
		if (!$item.find("[data-subnav-subitems]").length) {
			return;
		}

		clearTimeout(closeTimeout);
		closeAllSubnavs($item);
		$item.addClass("is-open");
		$item.find("[data-subnav-trigger]").attr("aria-expanded", "true");
	}

	$(".subnav__item")
		.on("mouseenter", function () {
			if ($(window).width() >= desktopBreakpoint) {
				openSubnav($(this));
			}
		})
		.on("mouseleave", function () {
			var $item = $(this);

			if ($(window).width() >= desktopBreakpoint) {
				closeTimeout = setTimeout(function () {
					if (!$.contains($item.get(0), document.activeElement)) {
						closeSubnav($item);
					}
				}, 100);
			}
		})
		.on("focusin", function () {
			if ($(window).width() >= desktopBreakpoint) {
				openSubnav($(this));
			}
		})
		.on("focusout", function () {
			var $item = $(this);

			if ($(window).width() >= desktopBreakpoint) {
				setTimeout(function () {
					if (!$.contains($item.get(0), document.activeElement)) {
						closeSubnav($item);
					}
				}, 0);
			}
		});

	$("[data-subnav-trigger]").on("click", function () {
		var $trigger = $(this);
		var $item = $trigger.closest(".subnav__item");

		if ($(window).width() >= desktopBreakpoint) {
			return;
		}

		if ($item.hasClass("is-open")) {
			closeSubnav($item);
			return;
		}

		openSubnav($item);
	});

	$(document).on("keydown", function (event) {
		if ("Escape" === event.key) {
			closeAllSubnavs();
		}
	});
});
